var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62771 3.06641C5.10929 3.06641 3.06771 5.10799 3.06771 7.62641C3.06771 10.1448 5.10929 12.1864 7.62771 12.1864C8.86947 12.1864 9.9953 11.6901 10.8176 10.8849C10.8187 10.8839 10.8198 10.8829 10.8208 10.8818C11.6644 10.0543 12.1877 8.90146 12.1877 7.62641C12.1877 5.10799 10.1461 3.06641 7.62771 3.06641ZM12.2128 11.3292C13.031 10.3173 13.521 9.02907 13.521 7.62641C13.521 4.37161 10.8825 1.73308 7.62771 1.73308C4.37291 1.73308 1.73438 4.37161 1.73438 7.62641C1.73438 10.8812 4.37291 13.5197 7.62771 13.5197C8.99933 13.5197 10.2615 13.0512 11.2629 12.2653L13.1375 14.0789C13.4021 14.3349 13.8242 14.3279 14.0802 14.0633C14.3362 13.7987 14.3292 13.3766 14.0646 13.1206L12.2128 11.3292ZM6.93437 4.79974C6.93437 4.43155 7.23285 4.13308 7.60104 4.13308C9.29471 4.13308 10.6677 5.50607 10.6677 7.19974C10.6677 7.56793 10.3692 7.86641 10.001 7.86641C9.63285 7.86641 9.33437 7.56793 9.33437 7.19974C9.33437 6.24245 8.55833 5.46641 7.60104 5.46641C7.23285 5.46641 6.93437 5.16793 6.93437 4.79974Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.6bbbe9bc4cccf1d8fd4a76c53abc2532.svg";
export { ForwardRef as ReactComponent };